import React, { useState } from 'react';
import KnopColorPicker from 'containers/HandlesPanel/CupColorPicker';
import { PaneMaterial, PositionAngle } from 'lib/modelBuilder/constants';
import { HandleUserSelection } from 'containers/HandlesPanel/types';
import ButtonTypePicker from 'containers/HandlesPanel/ButtonTypePicker';
import TypePickerLargeDoorHandle from 'containers/HandlesPanel/DoorHandlesSubPanel/TypePickerLargeDoorHandle';
import useMedia from 'use-media';
import { PickerTitleCategory } from '../../../components/PickerTitleCategory';
import { useTranslation } from 'react-i18next';

interface Props {
  handlePositionSelected: HandleUserSelection[];
  bigShelves: boolean;
  paint?: boolean;
}

enum PickerHandleSelection {
  knop = 'Knop',
  button = 'Button',
  slat = 'Slat',
}

const DoorHandlesSubPanel = ({
  handlePositionSelected,
  bigShelves = false,
  paint = false,
}: Props) => {
  function shouldDisplay() {
    if (paint) return true;
    return (
      handlePositionSelected.includes(PositionAngle.FrontLeft) ||
      handlePositionSelected.includes(PositionAngle.FrontRight) ||
      handlePositionSelected.includes(PositionAngle.BackRight) ||
      handlePositionSelected.includes(PositionAngle.BackLeft) ||
      handlePositionSelected.includes('Doors') ||
      handlePositionSelected.includes('Slats')
    );
  }
  const { t } = useTranslation();

  const isMobile = useMedia({ maxWidth: 1023 });

  const [pickerSelected, setPicker] = useState(PickerHandleSelection.knop);

  if (isMobile) {
    if (shouldDisplay()) {
      if (!bigShelves && !handlePositionSelected.includes('Slats')) {
        return (
          <div className="">
            <div className="flex bg-gray-300">
              <PickerTitleCategory
                selected={pickerSelected === PickerHandleSelection.knop}
                selectable
                onClick={() => {
                  setPicker(PickerHandleSelection.knop);
                }}
              >
                {t('Knop colors')}
              </PickerTitleCategory>
              <PickerTitleCategory
                selected={pickerSelected === PickerHandleSelection.button}
                selectable
                onClick={() => {
                  setPicker(PickerHandleSelection.button);
                }}
              >
                {t('Buttons')}
              </PickerTitleCategory>
            </div>
            {pickerSelected === PickerHandleSelection.knop && (
              <KnopColorPicker />
            )}
            {pickerSelected === PickerHandleSelection.button && (
              <ButtonTypePicker />
            )}
          </div>
        );
      } else {
        return <TypePickerLargeDoorHandle />;
      }
    } else return null;
  } else {
    if (shouldDisplay()) {
      if (!bigShelves && !handlePositionSelected.includes('Slats')) {
        return (
          <div className="flex">
            <div className="w-full lg:w-3/5">
              <KnopColorPicker />
            </div>
            <div className="w-full lg:w-2/5">
              <ButtonTypePicker />
            </div>
          </div>
        );
      } else {
        return (
          <div className="">
            <TypePickerLargeDoorHandle />
          </div>
        );
      }
    } else return null;
  }
};

export default DoorHandlesSubPanel;
